import { createContext } from "react";

export const LandDetailContext = createContext({})